import palette from '@lib/core/src/theme/palette';
import { Button, Stack, styled, Typography } from '@mui/material';

export const Container = styled(Stack)(() => ({
  height: '100%',
  width: '100%',
  padding: '40px',
  borderRadius: '16px',
  border: `1px solid ${palette.grey[1200]}`,
  background: palette.white,
  overflowY: 'auto'
}));

export const BackgroundRow = styled('div')(() => ({
  minHeight: '40px',
  width: '100%',
  borderRadius: '24px',
  opacity: 0.06,
  background:
    'linear-gradient(107deg, #E216A5 6.17%, #F6977A 41.84%, #F0D1D5 71.81%, #A15AD1 105.11%)'
}));

export const PlaceHolder = styled(Stack)(() => ({
  height: '100%',
  width: '100%',
  gap: '20px',
  overflow: 'hidden',
  position: 'relative'
}));

export const GenerateButtonStyle = styled(Button)({
  alignItems: 'center',
  justifyContent: 'center',
  width: '170px',
  height: '50px',
  backgroundColor: palette.white,
  borderRadius: '16px',
  border: 'none',
  zIndex: 1,
  cursor: 'pointer',
  textTransform: 'none',
  '&:disabled': {
    backgroundColor: palette.grey[200],
    color: palette.grey[500],
    opacity: 0.5,
    cursor: 'not-allowed',
    boxShadow: 'none'
  },
  boxShadow:
    '0 0 0 4px rgba(226,22,165,0.15), 0 2px 16px 0 rgba(246,151,122,0.10), 0 4px 32px 0 rgba(161,90,209,0.10)',
  '&:hover': {
    boxShadow:
      '0 0 0 6px rgba(226,22,165,0.18), 0 4px 24px 0 rgba(246,151,122,0.15), 0 6px 48px 0 rgba(161,90,209,0.15)'
  },
  '::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    borderRadius: '16px',
    padding: '2px',
    background:
      'linear-gradient(107deg, #E216A5 6.17%, #F6977A 41.84%, #F0D1D5 71.81%, #A15AD1 105.11%)',
    WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
    WebkitMaskComposite: 'xor',
    pointerEvents: 'none',
    zIndex: -1
  }
});

export const GenerateButton = styled(GenerateButtonStyle)({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)'
});

export const RegenerateButton = styled(GenerateButtonStyle)({
  alignSelf: 'flex-end',
  marginBottom: '20px'
});

export const GenerateButtonText = styled(Typography)({
  fontSize: '13px',
  color: palette.grey[500]
});
